import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { useState, useEffect } from "react";
import { FaAngleRight } from "react-icons/fa";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import OffcanvasSideBar from "./OffcanvasSideBar";
import { FrontEndLink } from "../../../Helper/config";
import { FiPhoneCall } from "react-icons/fi";
import { getAllCategories } from "./services";

const SideBar = ({ SetpanLeft, paneLeft }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => {
    SetpanLeft(false);
    setShow(true);
  };
  const toggleOffcanvas = () => setShow(!show);
  const handleCloseSidebar = () => setShow(false);

  const [offcanvasCategories, setOffcanvasCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const categories = await getAllCategories();

      setOffcanvasCategories(
        (categories || [])
          .filter((item) => item && item._id)
          .map((item) => ({ ...item, categoryName: item.name || "" })),
      );
    };

    fetchCategories();
  }, []);

  return (
    <>
      <div style={{ zIndex: 1300 }}>
        <SlidingPane
          className="slidingpaneLeft"
          isOpen={paneLeft}
          from="left"
          onRequestClose={() => SetpanLeft(false)}
          width={window.innerWidth >= 768 ? "320px" : "85%"}
        >
          <div className="slidingpane-content d-flex flex-column h-100">
            {/* Top Section */}
            <div>
              <div className="sidebar-pane-top">
                <a href={"/"} className="sidebar-brand-link">
                  <img
                    src={"/Assets/Img/Logo.png"}
                    className="sidebar-brand-logo"
                    alt="OwnFood"
                  />
                </a>
                <button
                  className="sidebar-close-btn"
                  onClick={() => {
                    SetpanLeft(false);
                  }}
                  aria-label="Close menu"
                >
                  <X size={18} />
                </button>
              </div>

              <div className="sidebar overflow-hidden">
                {/* Sidebar Items */}
                <div className="sidebar-item">
                  <Link
                    to={"/earn-money"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>Earn Money</span>
                    </div>
                  </Link>
                </div>
                <div className="sidebar-item">
                  <Link
                    to={"/become-seller"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>Become a Seller</span>
                    </div>
                  </Link>
                </div>
                <div className="sidebar-item">
                  <Link
                    to={"/become-merchant"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>Become a Merchant</span>
                    </div>
                  </Link>
                </div>
                <div className="sidebar-item">
                  <div className="sidebar-title" onClick={handleShow}>
                    <span>Category</span>
                    <FaAngleRight size={25} />
                  </div>
                </div>
                <div className="sidebar-item">
                  <Link
                    to={"/all-recipes"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>Recipe</span>
                    </div>
                  </Link>
                </div>
                <div className="sidebar-item">
                  <Link
                    to={"/about-us"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>About Us</span>
                    </div>
                  </Link>
                </div>
                <div className="sidebar-item">
                  <Link
                    to={"/contact-us"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>Contact Us</span>
                    </div>
                  </Link>
                </div>
                <div className="sidebar-item">
                  <Link
                    to={"/terms"}
                    className="d-block"
                    onClick={() => SetpanLeft(false)}
                  >
                    <div className="sidebar-title">
                      <span>Terms &amp; Conditions</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Bottom Section */}
            <div className="mt-auto p-3 sidebar-footer">
              <h6 className="sidebar-helpline">
                <FiPhoneCall /> Helpline:{" "}
                <a style={{ color: "black" }} href="tel:+8809643123456">
                  +8809643123456
                </a>
              </h6>
              <h6 className="d-lg-none mt-1 mb-1">App Version: 1.1.1.1</h6>
            </div>
          </div>
        </SlidingPane>
      </div>

      <OffcanvasSideBar
        show={show}
        toggleOffcanvas={toggleOffcanvas}
        handleCloseSidebar={handleCloseSidebar}
        data={offcanvasCategories}
      />
    </>
  );
};

export default SideBar;
